import { Checkbox } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useReactToPrint } from "react-to-print";
import Table from "../../components/table/Table";

const PrintExportCategoryList = () => {
  let dispatch = useDispatch();

  //   useEffect(() => {
  //     dispatch(fetchAllProduct());
  //   }, [dispatch]);

  let productState = useSelector((state) => {
    return state.productReducer;
  });

  let { products } = productState;
  const exportCategoryNameList = [
    "Ruby",
    "Blue Sapphire",
    "Green Sapphire",
    "Peach Sapphire",
    "Mix Sapphire",
    "Star Sapphire",
    "Padparadscha",
    "TSavorite",
    "Spinel",
    "Tourmaline",
    "Alexandrite",
    "Aquamarine",
    "Cats eye",
    "Garnet",
    "Precious",
    "Semi Precious",
  ];
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [TotalItems, setTotalItems] = useState(0);
  const componentRef = useRef();
  useEffect(() => {
    let _load = products.filter(
      (x) => !x.isSold && exportCategoryNameList.includes(x.exportMainCategory)
    );

    const res = _load.reduce((acc, curr) => {
      if (!acc[curr.exportMainCategory]) acc[curr.exportMainCategory] = []; //If this type wasn't previously stored
      acc[curr.exportMainCategory].push(curr);
      return acc;
    }, {});

    var arr = [];
    var count = 0;

    for (var key in res) {
      if (res.hasOwnProperty(key)) {
        arr.push([key, res[key].sort((a, b) => a.weight - b.weight)]);
        count = count + res[key].length;
      }
    }

    setTotalItems(count);
    setFilteredProducts(arr);
    console.log(arr);
  }, [products]);

  const allItemTableHead = [
    "checkbox",
    "No",
    "title",
    "ID",
    "Pcs",
    "N/H",
    // "category",
    "Carat", //weight
    "origin",
    // "shape",
    "buying",
    "estimated",
    "sold",
    "Buyer",
    "Remark",
  ];

  const finalRenderBody = (item, index) => (
    <tr
      className="text-sm font-extrabold"
      style={{ color: "var(--txt-color)" }}
      key={index}
    >
      <td className="checkbox" style={{ width: 10 }}>
        <Checkbox
          onChange={(e) => checkItem(item.productId, e.target.checked)}
          checked={item.check || false}
        ></Checkbox>
      </td>

      <td className="no">{index + 1}</td>
      <td>{item.title}</td>
      <td className="id">{item.productId}</td>
      {/* <td>{item.category}</td> */}
      {/* <td>{item.description}</td> */}
      {/* <td>{item.date}</td> */}
      {/* <td>{item.clarity}</td> */}
      {/* <td>{item.need_recut}</td> */}
      <td>{item.buyPiece || 1}</td>
      <td className="id">
        {item.treatment_type === "Natural"
          ? "N"
          : item.treatment_type === "Heated"
          ? "H"
          : item.treatment_type}
      </td>
      <td className="id">{item.weight}</td>
      <td>{item.origin}</td>
      {/* <td>{item.shape}</td> */}
      {/* <td>{item.dimension}</td> */}
      <td className="text-right">
        <span>{Number(item.buyPrice).toLocaleString()}</span>{" "}
        <span style={{ width: 35 }} className="">
          {item.buyCurrency}
        </span>
      </td>
      {/* <td className="text-right">
        <span>{Number(item.sellPriceLocal).toLocaleString()}</span>{" "}
        <span style={{ width: 35 }} className="">
          {item.sellLocalCurrency}
        </span>
      </td> */}

      <td className="text-right">
        <span>{Number(item.sellPriceForeigners).toLocaleString()}</span>{" "}
        <span style={{ width: 35 }} className="">
          {item.sellForeignersCurrency}
        </span>
      </td>
      {/* <td>{item.supplier[0]?.firstName || ""}</td> */}
      <td style={{ width: 120 }}></td>
      <td style={{ width: 120 }}></td>
      <td style={{ width: 120 }}></td>
    </tr>
  );

  const [checked, setChecked] = React.useState(true);

  const handleChange = (event) => {
    setChecked(event.target.checked);

    checkAll(event.target.checked);
  };

  const checkAll = (value) => {
    // setCheckedAll(value)
    console.log("checked all");
    let filteredPro = JSON.parse(
      JSON.stringify(products.filter((x) => !x.isSold))
    );
    filteredPro.map((x) => (x.check = value));

    filteredPro.map((x, i) => {
      x.check = value;
      x.no = i + 1;
    });
    console.log("inside checkall", filteredPro);

    // setfilteredProducts(filteredPro);
  };

  const checkItem = (id, value) => {
    let filteredPro = filteredProducts.map((x) => {
      if (x.productId === id) x.check = value;

      return x;
    });
    // filteredPro.check = true
    console.log("item checked", filteredPro);

    // setfilteredProducts(filteredPro);
  };

  const renderHead = (item, index) => (
    <th
      style={{
        width: item === "checkbox" ? 10 : 120,
        minWidth: item === "Carat" ? 10 : "120px !important",
      }}
      className={
        item === "checkbox"
          ? "checkbox"
          : item === "No"
          ? "no"
          : item === "ID"
          ? "id"
          : item === "N/H" || item === "Carat"
          ? "id"
          : ""
      }
      key={index}
    >
      {item === "checkbox" ? (
        <Checkbox
          checked={checked}
          onChange={handleChange}
          inputProps={{ "aria-label": "controlled" }}
        />
      ) : (
        item
      )}
    </th>
  );

  const print = useReactToPrint({
    pageStyle: `  
    @media print{
        ::-webkit-scrollbar {
            display: none;
          }
.checkbox{
  display:none;
}

.pagebreak {
   
  min-height: 1px;
  page-break-before: always;
}

.no{
  width:10px !important
}
.id{
  width:30px !important
}
        div{
        color: black !important;
    }    
        table{
            color: black !important;
            padding-left: 50px !important;
            padding-right: 50px !important;
        }
        thead {
            background-color: black !important;
            color:white;

        }
        td{
padding:3px !important;
border: 1px solid black;
width:120px;
color:black !important;
        }
        th{
          padding: 4px 16px !important;
        }
            
      @page {
          margin: 10px;
          margin-bottom: 10px;
          size: A3;
          
           }
      body{
        -webkit-print-color-adjust: exact;
          font-size:9px;
          color:#000 !important;
        
      }
      section{
      
      background-color: white;
  }
  
  h1{
      font-size: 10px;
      
  }
  p{
      font-size: 9px;
  }
  table{
    width:100%;
    font-size: 10px;
  }
  td{
    font-size: 10px;
  }
  }
    `, // remove date/time from top

    // pageStyle:"@page { size: 8-1/4in 11-3/4in }",
    content: () => componentRef.current,
  });

  function setPageSize(cssPageSize) {
    const style = document.createElement("style");
    style.innerHTML = `@page {  margin: 30px; size: ${cssPageSize}`;
    style.id = "page-orientation";
    document.head.appendChild(style);
  }

  const printSelectedItems = () => {
    setPageSize("landscape");
    // setfilteredProducts(filteredProducts.filter((x) => x.check));
    setTimeout(() => {
      print();
    }, 1000);
  };

  return (
    <div className="flex flex-col">
      <div
        className="bg-blue-400 p-5 bx bx-printer w-3/12 cursor-pointer text-white text-center hover:bg-blue-700 hover:font-extrabold"
        onClick={() => {
          printSelectedItems();
        }}
      >
        Print
      </div>

      <div ref={componentRef}>
        <div className="flex flex-col w-full pl-4">
          <div className="font-extrabold text-sm flex justify-center">
            SHIMLA GEM REPORTS{" "}
          </div>
          <div className="font-extrabold text-xs flex justify-center">
            EXPORT CATEGORY WISE LIST - ({TotalItems})
          </div>
          <div className="m-2">{new Date().toDateString()}</div>
          <hr></hr>
        </div>
        {filteredProducts.map((x) => {
          return (
            <div className="flex flex-col w-full my-4">
              <div className="flex my-3 text-2xl font-extrabold w-full ">
                {x[0]} ( <div>{x[1].length}</div>)
              </div>
              <hr></hr>
              <Table
                //   limit="10"
                headData={allItemTableHead}
                renderHead={(item, index) => renderHead(item, index)}
                bodyData={x[1]}
                renderBody={(item, index) => finalRenderBody(item, index)}
              ></Table>

              <div className="flex flex-col w-full justify-end items-end my-4">
                <div className="flex w-4/12 text-sm font-extrabold justify-between items-end my-1">
                  <div>Total Purchase Amount : </div>
                  <div>
                    {x[1]
                      .reduce((accumulator, currentValue) => {
                        return accumulator + Number(currentValue.buyPrice);
                      }, 0)
                      .toLocaleString()}{" "}
                    LKR
                  </div>
                </div>
                <div className="flex w-4/12 text-sm font-extrabold justify-between items-end my-1">
                  <div>Total Piece Count : </div>
                  <div>
                    {x[1].reduce((accumulator, currentValue) => {
                      return accumulator + Number(currentValue.buyPiece);
                    }, 0)}
                  </div>
                </div>
                <div className="flex w-4/12 text-sm font-extrabold justify-between items-end my-1">
                  <div>Total Carat Count : </div>
                  <div>
                    {" "}
                    {x[1]
                      .reduce((accumulator, currentValue) => {
                        return accumulator + Number(currentValue.weight);
                      }, 0)
                      .toFixed(3)}
                  </div>
                </div>
              </div>
            </div>
          );
        })}

        {/* <hr></hr>
        <div>
          <div className="flex font-extrabold justify-evenly"></div>
        </div> */}
      </div>
    </div>
  );
};

export default PrintExportCategoryList;
